<template>
    <div class="container-fluid">
        <div class="row mt-2 mb-5">
            <div class="offset-md-2 col-md-8 col-12">
                <!-- stage numbering -->
                <div class="row my-2">
                    <div class="col-12 text-center">
                        <router-link :to="{ name: 'checkout-information' }" class="text-dark-green">
                            Information
                        </router-link> &gt;
                        <router-link :to="{ name: 'checkout-shipping' }" class="text-dark-green">
                            Shipping
                        </router-link> &gt;
                        <span class="text-dark-green">Payment</span>
                    </div>
                </div>

                <!-- import cart review -->
                <app-cart-review class="my-3"></app-cart-review>

                <!-- show shipping items -->
                <template v-if="convertedTotalCost && theCurrency">
                    <form enctype="multipart/form-data">
                        <div class="row">
                            <div class="col-12">
                                <div class="card">
                                    <div class="p-2 bg-silver text-right">
                                        <div>
                                            <p class="float-left my-0">Subtotal: </p>
                                            <p class="float-right my-0 font-weight-bold">{{convertedTotalCost.currency}} {{convertedTotalCost.itemsCost | money}}</p>
                                            <div class="clearfix"></div>
                                        </div>
                                        <div>
                                            <p class="float-left my-1">Shipping: </p>
                                            <p class="float-right my-1 font-weight-bold">{{convertedTotalCost.currency}} {{convertedTotalCost.shippingCost | money}}</p>
                                            <div class="clearfix"></div>
                                        </div>
                                        <div>
                                            <p class="float-left my-0">Service: </p>
                                            <p class="float-right my-0 font-weight-bold">{{convertedTotalCost.currency}} {{convertedTotalCost.serviceFee | money}}</p>
                                            <div class="clearfix"></div>
                                        </div>
                                        <hr class="my-2">
                                        <div>
                                            <p class="float-left">Total: </p>
                                            <h5 class="float-right font-weight-bold text-dark-green">{{convertedTotalCost.currency}} {{convertedTotalCost.grandCost | money}}</h5>
                                            <div class="clearfix"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- display flutterwave payment button -->
                        <div class="row mt-3">
                            <div class="col-12">
                                <div class="accordion" id="accordionExample">
                                    <!-- online payment -->
                                    <div class="card">
                                        <div class="card-header p-0 bg-silver" id="headingOne">
                                            <p class="m-0">
                                                <button 
                                                    class="btn btn-block text-left font-weight-bold" 
                                                    type="button" data-toggle="collapse" data-target="#collapseOne" 
                                                    aria-expanded="true" aria-controls="collapseOne"
                                                    @click.prevent="onlineRadioFxn">
                                                    <i v-if="onlineRadioChk" class="fas fa-dot-circle text-dark-green"></i> 
                                                    <i v-else class="far fa-circle"></i> 
                                                    Online Payment
                                                </button>
                                            </p>
                                        </div>
                                        <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                                            <div class="card-body payment-notes">
                                                <p class="m-0">
                                                    Pay with Flutterwave using your Master Card, Visa Card, ATM Card, etc.  
                                                    although it could add a very little extra cost, very small, 
                                                    but we receive and start processing your order immediately after your successful payment! 
                                                    Definitely worth the speed 😉
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- bank transfer -->
                                    <div class="card">
                                        <div class="card-header p-0 bg-silver" id="headingTwo">
                                            <p class="m-0">
                                                <button 
                                                    class="btn btn-block text-left font-weight-bold collapsed" 
                                                    type="button" data-toggle="collapse" data-target="#collapseTwo" 
                                                    aria-expanded="false" aria-controls="collapseTwo"
                                                    @click.prevent="bankRadioFxn">
                                                    <i v-if="bankRadioChk" class="fas fa-dot-circle text-dark-green"></i> 
                                                    <i v-else class="far fa-circle"></i>
                                                    Bank Transfer
                                                </button>
                                            </p>
                                        </div>
                                        <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                                            <div class="card-body payment-notes">
                                                <p>
                                                    Make a payment by means of transfer to our 
                                                    <span class="font-weight-bold">parent company</span> official bank account.
                                                </p>
                                                <p class="font-weight-bold">
                                                    Brondchux Company Nig. Ltd.
                                                    <br>5600366870
                                                    <br>Fidelity Bank
                                                </p>
                                                <p>
                                                    When completed, upload your proof of payment below, 
                                                    your order will be processed as soon as we confirm your payment.
                                                </p>
                                                <input @change="uploadReceiptFxn" type="file" accept="image/jpeg, image/png, image/gif" class="form-control">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- display alert messages for mobile -->
                        <div v-if="msg !== ''" :class="`alert alert-${color} text-center mt-3 p-1`" role="alert">
                            <i class="fas fa-exclamation-circle fa-sm"></i> {{ msg }}
                        </div>

                        <!-- continue to payment button -->
                        <div class="row mt-3">
                            <div class="col-12">
                                <div class="float-sm-right">
                                    <button @click.prevent="paymentMethodFxn" class="loadn btn btn-dark-green form-control">
                                        <span v-if="onlineRadioChk">Pay Now</span>
                                        <span v-else>Complete Order</span>
                                    </button>
                                </div>
                                <div class="float-sm-left">
                                    <p class="text-center m-0 pt-2">
                                        <router-link :to="{ name: 'checkout-shipping' }">
                                            <i class="fas fa-chevron-left fa-xs"></i> Return to Shipping
                                        </router-link>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </form>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import CartReview from './CartReview.vue';
import LayoutGeneral from '@/layouts/General.vue'

export default {
    name: "Payment",
    data() {
        return {
            totalCost: null,
            convertedTotalCost: null,
            onlineRadioChk: true,
            bankRadioChk: false,
            photosArr: [],
            msg: '',
            color: 'danger'
        }
    },
    methods: {
        ...mapActions(['completeOrderAction']),
        uploadReceiptFxn(e) {
            // empty the arrays first
            this.photosArr = []
            let images = e.target.files
            for(let x=0; x < images.length; x++){
                let reader = new FileReader()
                reader.readAsDataURL(images[x])
                reader.onload = e => {
                    let photoObj = {
                        path: images,
                        main: false
                    }
                    this.photosArr.push(photoObj)
                }   
            }
        },
        paymentMethodFxn() {
            if(!this.theCurrency) return
            if(!this.totalCost) return
            if(!this.totalCost.grandCost) return
            if(this.bankRadioChk && !this.photosArr.length) { 
                this.msg = "Upload your proof of payment to proceed with 'Bank Transfer' method. " 
                this.msg += "Otherwise use 'Online Payment' method!"; return 
            }

            // determine the shoppers payment method
            let shopperPaymentMethod = this.onlineRadioChk ? "online payment" : "bank transfer"

            // fetch the shopper details from local storage
            let localStorageSHPDetails = JSON.parse(localStorage.getItem('ani_items_shp')) 
            if(localStorageSHPDetails) { 
                
                // update the shopper details with the chosen payment method and proof-of-payment if any
                let existingShopperObj = localStorageSHPDetails
                existingShopperObj.userId = this.shopperUserId
                existingShopperObj.paymentMethod = shopperPaymentMethod
                existingShopperObj.paymentCurrency = this.theCurrency.code
                existingShopperObj.paymentRate = this.theCurrency.rate
                existingShopperObj.paymentAmount = this.totalCost.grandCost
                localStorage.setItem('ani_items_shp', JSON.stringify(existingShopperObj))
            }

            // run the complete order fxn
            this.completeOrderFxn()
        },
        completeOrderFxn() {
            let processOrderObj = {}
            
            // fetch the shopper details from local storage
            let localStorageSHPDetails = JSON.parse(localStorage.getItem('ani_items_shp')) 
            if(localStorageSHPDetails) { 
                processOrderObj.shopperDetails = localStorageSHPDetails 
            }
            
            // fetch the shopper cart items from local storage
            let localStorageATCItemIds = JSON.parse(localStorage.getItem('ani_items_atc')) 
            if(localStorageATCItemIds && localStorageATCItemIds.length) {
                processOrderObj.shopperCart = localStorageATCItemIds 
            }

            // add the photo arr here
            if(this.photosArr && this.photosArr.length){
                processOrderObj.photosArr = this.photosArr
            }

            // send to api endpoint via vuex
            this.completeOrderAction(processOrderObj)
            .then((data) => {
                if(!data.error){
                    this.color = 'success'
                    // redirect to shipping page
                    this.$router.push({
                        name: 'processing-order',
                        params: {
                            orderNumber: data.result.orderNumber,
                            paymentId: data.result.paymentId,
                            paymentMethod: data.result.paymentMethod
                        }
                    }).catch((e) => {})
                }
                this.msg = data.msg
            })
            .catch((e) => {})
        },
        resetDefaultsFxn() {
            this.msg = ''
            this.color = 'danger'
        },
        onlineRadioFxn() {
            this.onlineRadioChk = true
            this.bankRadioChk = false
            this.resetDefaultsFxn()
        },
        bankRadioFxn() {
            this.onlineRadioChk = false
            this.bankRadioChk = true
            this.resetDefaultsFxn()
        },
        calcCartItemsCostsFxn() {
            let totalCostObj = {
                itemsCost: 0,
                shippingCost: 0,
                serviceFee: 0,
                grandCost: 0,
            }
            
            // obtain the cart-items from local-storage and calculate their cost prices
            let localStorageATCItemIds = JSON.parse(localStorage.getItem('ani_items_atc')) 
            if(localStorageATCItemIds && localStorageATCItemIds.length) {
                localStorageATCItemIds.forEach(cartItemElement => {
                    totalCostObj.itemsCost += cartItemElement.itemSumPrice ? parseInt(cartItemElement.itemSumPrice) : 0,
                    totalCostObj.shippingCost += cartItemElement.shippingPrice ? parseInt(cartItemElement.shippingPrice) : 0
                });
                totalCostObj.grandCost = parseInt(totalCostObj.itemsCost + totalCostObj.shippingCost)
                totalCostObj.serviceFee = totalCostObj.itemsCost * 0.01 // one percent only
                totalCostObj.grandCost += totalCostObj.serviceFee
                this.totalCost = totalCostObj

                // convert the item price from US Dollar to Nigeria Naira using our rate
                if(this.theCurrency){
                    this.convertedTotalCost = {}
                    this.convertedTotalCost.currency = this.theCurrency.code.toUpperCase()
                    this.convertedTotalCost.itemsCost = this.totalCost.itemsCost * this.theCurrency.rate
                    this.convertedTotalCost.shippingCost = this.totalCost.shippingCost * this.theCurrency.rate
                    this.convertedTotalCost.serviceFee = this.totalCost.serviceFee * this.theCurrency.rate
                    this.convertedTotalCost.grandCost = this.totalCost.grandCost * this.theCurrency.rate
                }
            } 
        },
    },
    computed: {
        ...mapGetters(['setCurrency', 'authenticated', 'user']),
        theCurrency() {
            if(this.setCurrency) {
                return this.setCurrency
            }
            return false
        },
        shopperUserId() {
            if(this.authenticated && this.user){
                return this.user._id
            }
            return 'ani_guest_shopper'
        }
    },
    components: {
        appCartReview: CartReview
    },
    created() {
        this.calcCartItemsCostsFxn()
        this.$emit('update:layout', LayoutGeneral);
    },
}
</script>
